export default {
  tableCellItem: {
    wordBreak: 'break-all',
    overflowWrap: 'anywhere',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  },
  name: {
    marginLeft: '6px',
    fontSize: '0.875rem',
    fontFamily: 'inherit',
  },
  icon: {
    width: '38px',
    height: '38px',
  },
};
